<template>
  <div>
    <page-header
      :header="header"
      :subheader="subheader"
    >
      <!-- <button v-if="id" class="bg-white rounded-lg p-4 uppercase text-sm font-medium align-bottom mr-4" @click="destroy" :disabled="isSaving || isDeleting" :class="{ 'opacity-50': isSaving || isDeleting }">
        <i v-if="isDeleting" class="fas fa-circle-notch fa-fw fa-lg fa-spin" />
        <i v-else class="far fa-trash-alt fa-fw fa-lg" />
        Delete Alert
      </button> -->
      <button class="bg-tertiary text-white rounded-lg p-4 uppercase text-sm font-medium align-bottom" @click="save" :disabled="isSaving || isDeleting" :class="{ 'opacity-50': isSaving || isDeleting }">
        <i v-if="isSaving" class="fas fa-circle-notch fa-fw fa-lg fa-spin" />
        <i v-else class="far fa-save fa-fw fa-lg" />
        Save Alert
      </button>
    </page-header>

    <div class="mb-6 -mx-4 flex">
      <div class="w-full px-4">
        <div class="bg-white rounded-lg p-6 pt-0 mt-12">
          <div class="flex items-center border-b mb-6 pb-2">
            <page-icon-picker
              :icon="alert.call_to_action_icon"
              :color="alert.call_to_action_icon_color"
              @change="iconSelected"
            />
            <!-- <div
              class="w-32 h-32 -mt-12 mb-2 py-2 rounded-lg relative flex flex-col justify-center items-center cursor-pointer"
              :class="[ alert.call_to_action_icon_color ? alert.call_to_action_icon_color : 'bg-blue' ]"
              @click="iconPickerVisible = true"
            >
              <div class="absolute pin-t pin-r bg-white -mt-3 -mr-3 rounded-full border h-8 w-8 flex justify-center items-center">
                <i class="far fa-edit fa-fw" />
              </div>
              <i v-if="alert.call_to_action_icon" class="fas fa-5x text-white" :class="`fa-${alert.call_to_action_icon}`"></i>
              <span v-else class="pin-b text-white text-center text-xs font-medium px-4">
                Click to choose an icon
              </span>
            </div> -->
            <div class="w-2/3 ml-6">
              <input
                type="text"
                placeholder="Title"
                class="input w-full mb-2"
                :class="{ 'border-red': errorBag.get('subject') }"
                v-model="alert.subject"
              >
              <small class="block text-xs text-red-dark text-medium" v-text="errorBag.get('subject')" />
            </div>
          </div>

          <div class="border-b mb-6 pb-6">
            <textarea
              rows="8"
              class="input w-full"
              v-model="alert.description"
              placeholder="Enter Description"
            />
          </div>

          <div class="border-b -mx-2 mb-6 pb-6">
            <div class="inline-block w-1/2 px-2">
              <input
                type="text"
                class="input w-full"
                placeholder="Action"
                v-model="alert.call_to_action_text"
              >
            </div>
            <div class="inline-block w-1/2 px-2">
              <input
                type="url"
                class="input w-full"
                placeholder="Link"
                v-model="alert.call_to_action_link"
              >
            </div>
          </div>

          <div class="border-b -mx-2 mb-6 pb-6">
            <div class="inline-block w-1/2 px-2">
              <date-time-picker v-model="alert.start_at" format="d MMMM yyyy HH:mm" value-format="yyyy-MM-dd HH:mm:ss" constraint-format="yyyy-MM-dd HH:mm:ss" :class="['input w-full', { 'border-red-dark': errorBag.get('starts_at') }]" :min-date="moment().startOf('day')" :max-date="alert.expires_at" :minute-step="30">
                <template slot="choose-date">
                  Display notification from
                </template>
                <template slot="date">
                  <button class="bg-primary rounded py-2 px-4 text-white">
                    <i class="fas fa-arrow-left"></i> Set Date
                  </button>
                </template>
                <template slot="time">
                  <button class="bg-primary rounded py-2 px-4 text-white">
                    Set Time <i class="fas fa-arrow-right"></i>
                  </button>
                </template>
              </date-time-picker>
            </div>
            <div class="inline-block w-1/2 px-2">
              <date-time-picker v-model="alert.expires_at" format="d MMMM yyyy HH:mm" value-format="yyyy-MM-dd HH:mm:ss" constraint-format="yyyy-MM-dd HH:mm:ss" :class="['input w-full', { 'border-red-dark': errorBag.get('expires_at') }]" :min-date="alert.start_at" :minute-step="30">
                <template slot="choose-date">
                  Display notification to
                </template>
                <template slot="date">
                  <button class="bg-primary rounded py-2 px-4 text-white">
                    <i class="fas fa-arrow-left"></i> Set Date
                  </button>
                </template>
                <template slot="time">
                  <button class="bg-primary rounded py-2 px-4 text-white">
                    Set Time <i class="fas fa-arrow-right"></i>
                  </button>
                </template>
              </date-time-picker>
            </div>
          </div>

          <div class="border-b mb-6 pb-6">
            <input id="show_alert_as_popup" type="checkbox" v-model="alert.show_as_popup">
            <label for="show_alert_as_popup" class="text-grey-darkest text-sm font-normal">Show alert as popup</label>
          </div>

          <div v-if="system.networks.length > 1 && !id" class="mb-6">
            <strong>Send to Networks</strong>
            <div v-for="(network, i) in system.networks" :key="i" class="text-sm uppercase">
              <input type="checkbox" :id="'select'+i" v-model="alert.network_ids" :value="network.id">
              <label :for="'select'+i" class="mt-3">{{ network.name }}</label>
            </div>
          </div>
          <div v-if="clients.length > 1 && !id && alert.network_ids.includes(8)">
            <strong class="block mt-6">Send to Clients</strong>
            <div class="text-sm mt-3 w-1/2">
              <checkbox-input label="Select all" @input="toggleSelectAllCountries" :value="false" />
              <select-input
                v-model="alert.client_ids"
                :options="clients"
                class="-mt-3"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal v-if="iconPickerVisible" >
      <icon-picker />
    </modal>
  </div>
</template>

<script>
import api from '@/http'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import { map } from 'lodash'
import ErrorBag from '@/ErrorBag'
import IconPicker from '@/components/IconPicker'
// import { EventBus } from '@/EventBus'
import DateTimePicker from 'vue-vanilla-datetime-picker'

import PageIconPicker from '@/components/cms/PageIconPicker'

export default {
  props: ['id'],

  components: { IconPicker, PageIconPicker, DateTimePicker },

  data () {
    return {
      isSaving: false,
      isDeleting: false,
      iconPickerVisible: false,
      errorBag: new ErrorBag(),
      timePickerOptions: { start: '00:00', step: '00:30', end: '23:30' },
      alert: {
        subject: '',
        description: '',
        start_at: null,
        expires_at: null,
        call_to_action_text: null,
        call_to_action_link: null,
        call_to_action_icon_color: null,
        call_to_action_icon: null,
        show_as_popup: false,
        network_ids: [],
        client_ids: []
      },
      clients: []
    }
  },

  computed: {
    ...mapState([
      'system'
    ]),

    header () {
      return this.id
        ? 'Update Alert'
        : 'Create new Alert'
    },

    subheader () {
      return this.id
        ? 'Update an existing Network Alert.'
        : 'Create a new alert to display to everyone across your network.'
    }
  },

  methods: {
    moment: moment,

    ...mapActions([
      'updateAlert', 'displayToastNotification'
    ]),

    formatTimestamp (timestamp) {
      return this.moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
    },

    startDidChange () {
      this.alert.start_at = this.formatTimestamp(this.alert.start_at)

      if (this.alert.start_at >= this.alert.expires_at) {
        this.alert.expires_at = null
      }
    },

    iconSelected (data) {
      this.alert.call_to_action_icon = data.icon
      this.alert.call_to_action_icon_color = data.color
      this.iconPickerVisible = false
    },

    iconPickerCancelled () {
      this.iconPickerVisible = false
    },

    load () {
      if (this.id) {
        api.get(`/notification/${this.id}`).then((response) => {
          this.alert = response.data.data
          this.alert.id = this.id
          this.alert.network_ids = [this.alert.network_id]
          this.alert.start_at = this.alert.start_at ? this.moment(this.alert.start_at).format('YYYY-MM-DD HH:mm:ss') : null
          this.alert.expires_at = this.alert.expires_at ? this.moment(this.alert.expires_at).format('YYYY-MM-DD HH:mm:ss') : null
        })
        return
      }
      this.alert.network_ids = map(this.system.networks, 'id')
    },

    save () {
      this.errorBag.clear()

      this
        .updateAlert(this.alert)
        .then(response => {
          console.log(response)
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Saved',
            info: this.client_ids ? 'Client alert saved' : 'Network alert saved'
          })
          this.$router.push('/admin')
        })
        .catch(error => {
          this.errorBag.store(error.response.data)
          this.displayToastNotification({
            type: 'warning',
            icon: 'fa-bell',
            title: 'Save Failed',
            info: error.response.data.message
          })
        })
    },
    getClientList () {
      api.get(`/notification/client/list`, {
        params: {
          network_id: 8
        }
      }).then((response) => {
        this.clients = response.data
      })
      this.toggleSelectAllCountries(true)
    },
    toggleSelectAllCountries (flag) {
      if (flag) {
        this.alert.client_ids = []
        for (var index in this.clients) {
          this.alert.client_ids.push(this.clients[index].id)
        }
      } else {
        this.alert.client_ids = []
      }
    }

    // destroy () { }
  },

  watch: {
    system () {
      this.load()
    },
    'alert.network_ids' () {
      this.getClientList()
    }
  },

  created () {
    this.load()
    // EventBus.$on('icon-picker:cancel', this.iconPickerCancelled)
    // EventBus.$on('icon-picker:saved', this.iconSelected)
    this.getClientList()
  },

  beforeDestroy () {
    // EventBus.$off('icon-picker:cancel', this.iconPickerCancelled)
    // EventBus.$off('icon-picker:saved', this.iconSelected)
  }
}
</script>
